import React, { useEffect, useState, useCallback } from 'react';
import { useGame } from '../context/GameContext.jsx';
import { Scanner } from '@yudiel/react-qr-scanner';

const ScanScreen = () => {
  const { translations, lang, handleQrCodeScanned, setError } = useGame();

  // Removido: const [qrResult, setQrResult] = useState('');
  const [isScanning, setIsScanning] = useState(false);
  const [facingMode, setFacingMode] = useState('environment');

  const handleScanResult = useCallback((result) => {
    if (result && result.length > 0 && result[0] && result[0].rawValue) {
      const scannedData = result[0].rawValue;
      console.log('QR Code detected (Raw value):', scannedData); // Log the scanned code
      
      // Removido: setQrResult(`${translations[lang]?.scanned_prefix}: ${scannedData}`);
      handleQrCodeScanned(scannedData); 
    } else {
      console.warn('handleScanResult: Invalid QR Code result.', result);
      // Removido: setQrResult(translations[lang]?.qr_code_unrecognized);
    }
  }, [lang, translations, handleQrCodeScanned]);

  const handleScanError = useCallback((err) => {
    console.error('QR scanner error:', err);
    if (err.name === 'NotAllowedError' || err.name === 'NotFoundError') {
      setError(translations[lang]?.qr_scan_error_camera_access);
    } else {
      setError(translations[lang]?.unknown_error_occurred);
    }
    // Removido: setQrResult(translations[lang]?.qr_scan_stopped);
  }, [lang, translations, setError]);

  useEffect(() => {
    setIsScanning(true); 
    // Removido: setQrResult(translations[lang]?.qr_scan_looking);
    
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    setFacingMode(isMobile ? 'environment' : 'user');

    return () => {
      setIsScanning(false); 
    };
  }, [translations, lang]);

  const toggleCamera = useCallback(() => {
    setFacingMode(prev => (prev === 'environment' ? 'user' : 'environment'));
  }, []);

  const mirrorStyle = facingMode === 'user' ? 'scaleX(-1)' : 'scaleX(1)';

  return (
    <div className="scan-screen-container screen-content d-flex flex-column align-items-center justify-content-center text-center p-3">
      {/* Removido: Título e texto de instrução */}

      {isScanning && ( 
        <div className="qr-scanner-viewfinder position-relative w-100 h-100 d-flex flex-column justify-content-center align-items-center">
          <Scanner 
            onScan={handleScanResult}
            onError={handleScanError}
            scanDelay={500}
            constraints={{ facingMode: facingMode }}
          />
          <style>{`
            video {
              transform: ${mirrorStyle};
            }
          `}</style>
          <div className="qr-controls position-absolute bottom-0 w-100 d-flex justify-content-center align-items-center px-4 py-3">
            <button className="btn btn-secondary rounded-circle qr-control-button" onClick={(e) => { e.stopPropagation(); toggleCamera(); }} title={translations[lang]?.switch_camera}>
              <i className="fas fa-sync-alt"></i>
            </button>
          </div>
        </div>
      )}
      {/* Removido: qr-placeholder-message */}
    </div>
  );
};

export default ScanScreen;
